import React from "react";
import PropTypes from "prop-types";
// フォントIDごとにペアになるフォントを指定
const FONT_GROUPS = {
  17: "Star Times Text Pro Regular",
  18: "Star Times Text Pro Regular",
  19: "Prelude Condensed Pro Medium",
  20: "Prelude Condensed Pro Medium",
  21: "Star Times Text Pro Regular",
};

export default class EmbeddedStyle extends React.Component {
  render() {
    // サイトデザインがない場合はstyleタグ描画しない
    if (
      this.props.siteDesign.color_set_id === undefined ||
      this.props.siteDesign.font_id === undefined
    ) {
      return null;
    }

    // 選択したカセットカラーの特定
    const selectCassetteColor = this.props.designPresets.find((colorId) => {
      return parseInt(this.props.siteDesign.color_set_id, 10) === colorId.id;
    });

    // 選択したフォントの特定
    const selectFont = this.props.embeddedFonts.find((font) => {
      return parseInt(this.props.siteDesign.font_id, 10) === font.id;
    });

    return (
      <style
        dangerouslySetInnerHTML={{
          __html: `
                        .background-color--site{
                            background-color: ${this.props.siteDesign.site_color ?? "#E8E8E8"} !important;
                        }
                        .background-color--contents_bg{
                            background-color: ${selectCassetteColor.contents_bg} !important;
                        }
                        .background-color--label{
                            background-color: ${selectCassetteColor.label} !important;
                        }
                        .color--label_text{
                            color: ${selectCassetteColor.label_text} !important;
                        }
                        .color--text{
                            color: ${selectCassetteColor.text} !important;
                        }
                        .font-family--text{
                            font-family: '${
                              selectFont ? selectFont.value : ""
                            }' !important;
                        }
                        .font-family--date{
                            font-family: ${FONT_GROUPS[parseInt(this.props.siteDesign.font_id, 10)]} !important;
                        }
                        .fair-parts-center{
                            justify-content: center;
                        }
                    `,
        }}
      />
    );
  }
}

/**
 * embeddedFonts: フォント一覧
 * designPresets: デザイン一覧
 * siteDesign: サイトデザイン
 */
EmbeddedStyle.propTypes = {
  embeddedFonts: PropTypes.array.isRequired,
  designPresets: PropTypes.array.isRequired,
  siteDesign: PropTypes.object.isRequired,
};
